import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as navigationActions from "../../../../actions/navigationActions";
import * as componentTypes from "../../../../constants/componentTypes";
import * as tooltipHelper from "../../../../helpers/tooltipHelper";
import * as modelHelper from "../../../../helpers/modelHelper";

import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import imgClose from "../../../../resources/img/svgicons/cancel2.svg";
import imgEdit from "../../../../resources/img/svgicons/edit.svg";
import Modal from "../../../global/generic/Modal";

class NoteModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseNoteModalAction();
    };

    handleEditNoteModalClick = () => {
        this.props.dispatchCloseNoteModalAction();
        this.props.dispatchOpenEditNoteModalAction(this.props.tabId, this.props.params.note);
    };

    getMoreInfoData = () => {
        if (this.props.params.data === null || this.props.params.data.length === 0) {
            return null;
        }

        let moreInfoImages = [];
        let image = null;

        for (let moreInfo of this.props.params.data) {
            if (moreInfo.hasImage) {
                image = window.imageStore.getFormulaNoteImageById(moreInfo.id);

                if (image !== null) {
                    if (moreInfo.value === null) {
                        moreInfoImages.push(
                            <div key={moreInfo.id} className="pull-left img-list">
                                <img alt="" src={"data:" + image.type + ";base64," + image.img} />
                            </div>
                        );
                    } else {
                        moreInfoImages.push(
                            <div
                                key={moreInfo.id}
                                className="pull-left img-list"
                                data-text={moreInfo.value}
                                onMouseEnter={tooltipHelper.createTooltip}
                            >
                                <img alt="" src={"data:" + image.type + ";base64," + image.img} />
                            </div>
                        );
                    }
                }
            }
        }

        return <div className="image-section img-list col-xs-12">{moreInfoImages}</div>;
    };

    getEditButton = () => {
        if (this.props.params.editable) {
            return (
                <Button
                    className="margin-right-5"
                    onClick={this.handleEditNoteModalClick}
                    svgBefore={imgEdit}
                    label={<Translate value="general.edit" />}
                />
            );
        }

        return "";
    };

    getCancelButton = () => {
        if (this.props.params.editable) {
            return <CancelButton onClick={this.handleCloseModalClick} />;
        }
        return (
            <Button
                onClick={this.handleCloseModalClick}
                label={<Translate value="general.close" />}
                svgBefore={imgClose}
            />
        );
    };

    getMessage = () => {
        let structuredMessage = [];
        if (this.props.params.note !== undefined && this.props.params.note !== null) {
            let rows = this.props.params.note.split("\n");
            for (let [index, row] of rows.entries()) {
                structuredMessage.push(<p key={"message-row-" + index}>{row}</p>);
            }
        }

        return <React.Fragment>{structuredMessage}</React.Fragment>;
    };

    getContent = () => {
        if (this.props.params.data) {
            return modelHelper.buildModalSection(
                <React.Fragment>
                    {this.getMoreInfoData()}
                    <div className="col-12">{this.getMessage()}</div>
                </React.Fragment>,
                "slim-scroll flex-row-gap-10px flex-wrap col-12"
            );
        }
        return modelHelper.buildModalSection(<div className="slim-scroll">{this.getMessage()}</div>);
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <div className="flex">
                {this.getEditButton()}
                {this.getCancelButton()}
            </div>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                header={modelHelper.buildModalSection(<Translate value="general.note" />)}
                onClose={this.handleCloseModalClick}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "40%", maxWidth: "75%", minHeight: "20%", maxHeight: "50%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        imageStore: store.navigation.imageStore
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseNoteModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.NOTE_MODAL));
        },
        dispatchOpenEditNoteModalAction: (tabId, note) => {
            dispatch(navigationActions.openModalWithParams(tabId, componentTypes.EDIT_STATS_NOTE_MODAL, {note: note}));
        }
    };
};

export default NoteModal = connect(mapStoreToProps, mapDispatchToProps)(NoteModal);
